import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import { classNames } from '@yalendar/shared/ui-core';
import React from 'react';
import { useTranslation } from 'react-i18next';

var FAQ = function FAQ(_ref) {
  var faqs = _ref.faqs;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx("section", {
    className: "pt-6 pb-12 bg-gray-50",
    id: "faq",
    children: /*#__PURE__*/_jsxs("div", {
      className: "container max-w-5xl px-2 pt-4 pb-12 mx-auto text-gray-800",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "w-full my-2 text-5xl font-black leading-tight text-center text-gray-800",
        children: t('landing.navigations.faq')
      }), /*#__PURE__*/_jsx("div", {
        className: "w-full mb-2",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-64 h-1 py-0 mx-auto my-0 rounded-t opacity-25 gradient"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-2 text-center",
        children: /*#__PURE__*/_jsx("h3", {
          className: "text-2xl font-black text-gray-600",
          children: t('landing.frequentlyAskedQuestion')
        })
      }), /*#__PURE__*/_jsx("dl", {
        className: "mt-6 space-y-6 divide-y divide-gray-200",
        children: faqs.map(function (faq) {
          return /*#__PURE__*/_jsx(Disclosure, {
            as: "div",
            className: "pt-6",
            children: function children(_ref2) {
              var open = _ref2.open;
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("dt", {
                  className: "text-lg",
                  children: /*#__PURE__*/_jsxs(Disclosure.Button, {
                    className: "flex items-start justify-between w-full text-left text-gray-400",
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "font-medium text-gray-900 2xl:text-xl",
                      dangerouslySetInnerHTML: {
                        __html: faq.question
                      }
                    }), /*#__PURE__*/_jsx("span", {
                      className: "flex items-center ml-6 h-7",
                      children: /*#__PURE__*/_jsx(ChevronDownIcon, {
                        className: classNames(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform'),
                        "aria-hidden": "true"
                      })
                    })]
                  })
                }), /*#__PURE__*/_jsx(Disclosure.Panel, {
                  as: "dd",
                  className: "pr-12 mt-2",
                  children: /*#__PURE__*/_jsx("p", {
                    className: "text-base text-gray-500 xl:text-lg ",
                    dangerouslySetInnerHTML: {
                      __html: faq.answer
                    }
                  })
                })]
              });
            }
          }, faq.question);
        })
      })]
    })
  });
};

export default FAQ;